import { createContext } from 'react'

import { createDeptUserBaseStore } from '../store/createStore'

export const DeptUserBaseStoreContext = createContext<
  ReturnType<typeof createDeptUserBaseStore> | undefined
>(undefined)
